var React = require('react');

function ShowMenu (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-754.936 -520.143)"},React.createElement("g",{"transform":"translate(755.436 520.643)"},[React.createElement("rect",{"width":"13.754","height":"3.174","transform":"translate(9.522 14.812)","key":0}),React.createElement("rect",{"width":"13.754","height":"3.174","transform":"translate(9.522 6.877)","key":1}),React.createElement("rect",{"width":"13.754","height":"3.174","transform":"translate(9.522 22.747)","key":2}),React.createElement("rect",{"width":"32.798","height":"32.798","strokeWidth":"1","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","fill":"none","key":3})])));
}

ShowMenu.defaultProps = {"width":"33.798","height":"33.798","viewBox":"0 0 33.798 33.798"};

module.exports = ShowMenu;

ShowMenu.default = ShowMenu;
